<template>
  <CCol xl="6" class="mb-3">
    <div class="overview-widget" data-v-step="1">
      <div class="d-flex align-items-center mb-3">
        <h5 class="m-0" v-translate>Communicate how to access participants</h5>
        <PTooltip class="ml-2"
                  :content="tooltip.content()"
                  :color="tooltip.color"
                  :placement="tooltip.placement"/>
      </div>
      <PTabs
        :tabs="tabs"
        :selected="tab"
        @select="tab = $event"
      />
      <QRCodeGenerator ref="qrCodeGenerator"
                       v-if="tab === 'qrCode'"
                       :value="qrCode"
                       :direct="step && step.qr_code"
                       :short="step && step.short_qr_code"
                       :file-name="`QRCode-${picaServiceId}`"/>
       <MediaKit :media-kit="step" v-if="tab === 'pressKit'"/>
    </div>
  </CCol>
</template>

<script>
import PTooltip from "@/domain/core/components/PTooltip.vue";
import {tooltipEventWizard} from "@/domain/eventWizard/components/overview/tooltip";
import PTabs from "@/domain/core/components/PTabs.vue";
import MediaKit from "@/domain/eventWizard/components/overview/MediaKit.vue";
import QRCodeGenerator from "@/domain/core/components/qrcode/QRCodeGenerator.vue";
import {mapGetters} from "vuex";


export default {
  name: 'Tools',
  components: {QRCodeGenerator, MediaKit, PTabs, PTooltip},

  props: {
    step: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tab: 'pressKit'
    }
  },
  computed: {
    ...mapGetters('event', [
      'picaServiceId',
    ]),
    tabs() {
      return [
        {
          icon: 'cipLink',
          name: 'pressKit',
          label: `${this.$gettext('Direct link')}`
        },
        {
          icon: 'cipQrCode02',
          name: 'qrCode',
          label: `${this.$gettext('QR Code')}`
        }
      ]
    },
    tooltip() {
      return tooltipEventWizard.mediaKit
    },
    qrCode() {
      if (this.step && this.step.short_qr_code) return this.step.short_qr_code
      if (this.step) return this.step.qr_code
      return null
    },
  },
  methods: {}
}
</script>
